export default {
  address: {
    country: 'France',
    locality: 'Paris',
    postalCode: '75008',
    street: '8 Rue de Berri'
  },
  colors: {
    blue: '#104182'
  },
  topOffset: 80,
  server: {
    uploadMaxSize: 10485760
  },
  roles: {
    freelance: {
      name: 'ROLE_FREELANCE',
      value: 1 << 1,
    },
    do: {
      name: 'ROLE_DO',
      value: 1 << 2,
    },
    admin: {
      name: 'ROLE_ADMIN',
      value: 1 << 3,
    },
    businessManager: {
      name: 'ROLE_COMMERCIAL',
      value: 1 << 4,
    },
    support: {
      name: 'ROLE_SUPPORT',
      value: 1 << 5,
    }
  },
  civilities: {
    woman: "Mme",
    man: "M.",
  },
  partTime: {
    fullTimeOnly: {
      value: 3,
      label: 'Mission à temps plein uniquement'
    },
    partTimeOnly: {
      value: 2,
      label: 'Mission à temps partiel uniquement'
    },
    all: {
      value: 1,
      label: 'Mission sur tous les formats'
    }
  },
  companyTypes: {
    eurl: {profilValue: 'EURL', publicValue: 'EURL'},
    sas: {profilValue: 'SAS', publicValue: 'SAS'},
    sarl: {profilValue: 'SARL', publicValue: 'SARL'},
    ei: {profilValue: 'Entreprise Individuelle', publicValue: 'EI / EIRL'},
    freelance: {profilValue: 'Auto entrepreneur', publicValue: 'Auto entrepreneur'},
    freelance2: {profilValue: 'Freelance, en portage salarial ou autre', publicValue: 'Freelance'},
  },
  site: {
    name: 'Twineeds',
    phone: '+33 6 85 22 70 61',
    url: {
      full: 'https://www.twineeds.com',
      name: 'Twineeds.com',
    },
    emails: {
      contact: 'contact@twineeds.com'
    },
    cgu: {
      cnil: '2112719',
      tva: 'FR 74 832390421'
    },
    linkedinUrl: 'https://www.linkedin.com/company/twineeds'
  },
  calendly: {
    do: 'https://calendly.com/15mn-client',
  },
  downloadableFiles: {
    pressFile: `${process.env.API_URL}/files/press-file`,
  },
  languageLevels: {
    beginner: {value: 1, label: 'Notion'},
    medium: {value: 2, label: 'Moyen'},
    good: {value: 3, label: 'Bon niveau'},
    fluent: {value: 4, label: 'Courant'},
    native: {value: 5, label: 'Bilingue ou langue maternelle'},
  },
  availability: {
    0: 'Immédiate',
    1: '1 mois de préavis',
    2: '2 mois de préavis',
    3: '3 mois de préavis',
    '-1': 'Choisir une date'
  },
  restrictedEmails: [
    'gmail', 'ymail', 'yahoo', 'icloud', 'hotmail', 'live', 'outlook', 'bbox', 'free', 'sfr.fr', 'orange.fr',
    'laposte.net', 'wanadoo', 'aol', 'me.com', 'msn.com', 'neuf.fr', 'club-internet.fr', 'cegetel.net', 'aliceadsl.fr',
    'inseec-france.com', 'skema.edu', 'essec.edu', 'hec.edu', 'kedgebs.com', 'edu.escpeurope.eu', 'edu.em-lyon.com',
    'edhec.com'
  ],
  reviewSource: {
    phone: {
      name: 'Qualification par telephone',
      value: 1,
    },
    qualif: {
      name: 'RDV de qualification',
      value: 2,
    },
    customer: {
      name: 'Présenté en RDV client',
      value: 4,
    },
    work: {
      name: 'Nous avons collaboré ensemble',
      value: 8,
    }
  },
  reviewType: {
    do: 1,
    ssii: 2,
    admin: 4,
  },
  offerAnswerDenials: {
    0: 'Générique',
    1: 'Pertinence du profil',
    2: 'Tarification',
    3: 'Logistique',
    4: 'Abandon',
    5: 'Mail collectif',
  },
  allowedMimeTypes: {
    cv: {
      'application/vnd.oasis.opendocument.text': ['.odt'],
      'application/msword': ['.doc'],
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    skillsFile: {
      'application/vnd.oasis.opendocument.text': ['.odt'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    dropneed: {
      'application/vnd.oasis.opendocument.text': ['.odt'],
      'application/msword': ['.doc'],
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    userImage: {
      'image/jpeg': ['.jpeg, .jpg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
  },
  alert: {
    channels: {
      website: {
        value: 0,
        text: 'Sur la plateforme',
        disabled: true,
      },
      email: {
        value: 1,
        text: 'Par email'
      },
      sms: {
        value: 2,
        text: 'Par SMS'
      }
    },
    frequency: {
      weekly: {
        value: 3,
        text: 'une fois par semaine'
      },
      immediate: {
        value: 5,
        text: 'à chaque fois qu\'une mission est publiée'
      }
    }
  },
  notification: {
    type: {
      new_offer: {
        value: 1,
        text: 'Une nouvelle mission a été publiée'
      },
      edited_offer: {
        value: 2,
        text: 'Une mission a été modifiée',
      },
      closed_offer: {
        value: 4,
        text: 'Une mission a été pourvue',
      }
    }
  },
  contacts: {
    prospect: 0,
    reference: 1,
  },
  search: {
    limits: {
      cards: 20,
      list: 50
    },
    targets: {
      freelances: 'freelances',
      offers: 'offers',
      purchasers: 'purchasers'
    },
    topologies: {
      freelances: [
        {name: 'complete', labels: ['Complet', 'Non complet']},
        {name: 'active', labels: ['Actif', 'Supprimé']},
        // {name: 'public', labels: ['Public', 'Masqué']},
        // {name: 'upToDate', labels: ['À jour', 'En retard']},
        // {name: 'cv', labels: ['Avec CV', 'Sans CV']},
        // {name: 'linkedin', labels: ['Avec url Linkedin', 'Sans url Linkedin']},
        // {name: 'skillsFile', labels: ['DC uploadé', 'Pas de DC']},
        // {name: 'picture', labels: ['Avec photo', 'Sans photo']},
        // {name: 'meeting', labels: ['RDV planifié', 'Pas de RDV']},
        // {name: 'seen', labels: ['Vu en RDV', 'Non vu']},
        // {name: 'reviewed', labels: ['Noté', 'Non noté']},
        {name: 'gold', labels: ['Gold', 'Non gold']},
        {name: 'reliable', labels: ['Fiable', 'Douteux']},
        {name: 'onMission', labels: ['En mission', 'Pas en mission']},
        {name: 'cdi', labels: ['En CDI', 'Non CDI']},
        // {name: 'sms', labels: ['SMS actifs', 'SMS inactifs']},
      ],
      offers: {
        filled: 1 << 0,
        notFilled: 1 << 1,
        locked: 1 << 2,
        notLocked: 1 << 3,
        published: 1 << 4,
        notPublished: 1 << 5,
      }
    },
    experiences: [
      {
        name: '0-4',
        label: '0-4 ans'
      },
      {
        name: '5-10',
        label: '5-10 ans'
      },
      {
        name: '11-15',
        label: '11-15 ans'
      },
      {
        name: '16-20',
        label: '16-20 ans'
      },
      {
        name: '20',
        label: '+20 ans'
      }
    ]
  },
  situations: {
    permanentContract: {
      label: 'En CDI, et j’ai pour éventuellement pour projet d’effectuer des missions, je souhaite discuter de mon projet',
      value: 0
    },
    fixedTermContract: {
      label: 'En CDD et ouvert à une mission prochaine',
      value: 1
    },
    search: {
      label: 'Je suis actuellement en recherche d’une activité, peu importe le statut (CDI, mission…)',
      value: 2
    },
    portage: {
      label: 'Je suis déjà consultant indépendant, fonctionnant au portage',
      value: 3
    },
    structure: {
      label: 'Je suis déjà consultant indépendant, j\'ai monté ma structure (ou c\'est en cours)',
      value: 4
    }
  },
  workPermits: {
    european: {
      value: 0,
      label: 'Je suis français ou ressortissant de l\'UE'
    },
    workAuthorization: {
      value: 1,
      label: 'Je ne suis pas ressortissant de l\'UE mais j\'ai une autorisation de travail'
    },
    noAuthorization: {
      value: 2,
      label: 'Je n\'ai pas encore le droit de travailler en France'
    }
  }
};
